import { Plainte } from "../../model/Plainte";

export const initialState: Plainte = {
  personneAddressantPlainte: "",
  avecNeq: null,
  neq: "",
  raisonSansNeq: "",
  precisionSansNeq: "",
  contact: {
    nom: "",
    prenom: "",
    titre: "",
    courriel: "",
    telephone: ""
  },
  representant: {
    nomRepresentantPlaignant: "",
    nomPersonneAContacter: "",
    prenomPersonneAContacter: "",
    titrePersonneAContacter: "",
    courrielPersonneAContacter: "",
    telephonePersonneAContacter: "",
  },
  representantsOrganismePublic: [],
  interetProcessusAdjucationAttribution: null,
  raisonNonParticipationProcessus: "",
  ordonnanceOuRecommandationAmp: null,
  antecedentExerciceRecoursJudiciaire: null,
  nomOrganismeResponsableProcessusAdjucation: "",
  porterPlainteOrganismePublicAvantAMP: null,
  numeroDossierDetailsOrganismePublic: "", 
  interetRealiserContrat: false,
  recuDecisionOrganismePublic: null,
  dateDeReceptionDetailsOrganismePublic: null,
  appelOffre: {
    numeroSeao: "",
    numeroReference: "",
    titreAvis: "",
    dateLimiteReceptionPlainte: null,
    dateLimiteReceptionOffre: null,
    titreAddenda: "",
    datePublication: null,
    titreDocument: "",
    datePrevueConclusionContrat: null,
  },
  motifsPlainte: "",
  titresDocumentsTouches: "",
  documentsTouches: "",
  autresRenseignementsDesaccord: "",
  autresRenseignementsPertinents: "",
  attestationDeLaVeracite: false,

  typeDemande: "",
  desaccordDecision: false,
  decisionNonRecue: false,
  documentsModifiesDurantPeriodeAvantDateLimiteOuAvisIntentionNonPublie: false,
  aucuneSituation: false,

  prenomPlaignant: "",
  nomPlaignant: "",
  datePlainte: ""
};